import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes, a as addClassNames } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes, b as addMarginClasses } from './spacing-7e57ffb0.js';

/**
 *
 * @deprecated since 3.0.0. Use individual Icon React components instead.
 * Component will be removed in the next major release.
 */
function Icon({
  type,
  size,
  className,
  margin,
  color,
  ...htmlProps
}) {
  let cssClasses = ['st_icon', `st_icon--${size}`];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addMarginClasses(margin, cssClasses);
  if (color) cssClasses.push(`st_icon--color-${color}`);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: cssClasses.join(' ')
  }, htmlProps), /*#__PURE__*/React.createElement("use", {
    xlinkHref: `#icon-${type}`
  }));
}
Icon.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg']),
  /** type of icon */
  type: PropTypes.string.isRequired,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for icon, if any */
  margin: marginPropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white'])
};
Icon.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { Icon as default };
